import { FRONTAL_WORK } from '@yandex-int/k-common/constants';
import { Person, PlayOutline } from 'education-icons';
import { Button, SimpleText, useGeneratePath, useStaticUrls, useMe } from 'platform-components';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import * as lessonSelectors from 'common.components/lesson/selectors';
import { actions as problemsViewActions } from 'store/problems-view/actions';

import './custom-lesson-view__button.scss';

interface Props {
    type: BUTTON_TYPES;
}

export enum BUTTON_TYPES {
    TEACHER_DISPLAY = 'teacher_display',
    TEACHER_VIEW_AS_STUDENT = 'teacher_view_as_student',
    UNKNOWN = 'unknown',
}

export const CustomLessonViewButton = React.memo((props: Props) => {
    const { type } = props;
    const dispatch = useDispatch();
    const firstLessonProblemId = useSelector(lessonSelectors.getFirstLessonProblemId);
    const lessonMeta = useSelector(lessonSelectors.getLessonMeta);
    const lessonId = useSelector(lessonSelectors.getLessonId);
    const generatePath = useGeneratePath();
    const staticUrls = useStaticUrls();
    const me = useMe();

    let textId;

    if (type === BUTTON_TYPES.TEACHER_DISPLAY) {
        textId = 'lessonView.putOnBoard';
    } else if (type === BUTTON_TYPES.TEACHER_VIEW_AS_STUDENT) {
        textId = 'customLessonView.showCardsButton';
    }

    const handleClick = useCallback(() => {
        ym('reachGoal', type, {
            teacher_id: me?.id,
            lessonId,
        });

        if (lessonMeta?.is_public && lessonId) {
            let lessonUrl = generatePath(staticUrls.classroomPublicLessonRun, { lessonId });

            if (type === BUTTON_TYPES.TEACHER_DISPLAY) {
                lessonUrl = `${lessonUrl}?${FRONTAL_WORK}=true`;
            }

            window.open(lessonUrl, '_blank', 'noopener');
            return;
        }

        if (firstLessonProblemId) {
            dispatch(problemsViewActions.setSelectedProblemId(firstLessonProblemId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firstLessonProblemId, lessonId, lessonMeta]);

    if (!firstLessonProblemId) {
        return null;
    }

    return (
        <Button
            className="custom-lesson-view__button"
            icon={type === BUTTON_TYPES.TEACHER_VIEW_AS_STUDENT ? <Person /> : <PlayOutline />}
            onClick={handleClick}
            view={Button.VIEW.SECONDARY}
        >
            <SimpleText id={textId} />
        </Button>
    );
});
